import SeoContent from "../components/shared/SeoContent";
import { SCHOOL_SUPPORT_EMAIL, SCHOOL_SUPPORT_NUMBER } from "../constants";
import SchoolMapLocation from "./sections/SchoolMapLocation";
import { FaPhone } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { useState } from "react";

export default function ContactUsPage() {
    const contactInfo = [
        {
            id: 1,
            icon: <FaPhone className="text-white" size={22} />,
            title: "contact number",
            description: SCHOOL_SUPPORT_NUMBER,
        },
        {
            id: 2,
            icon: <MdEmail className="text-white" size={24} />,
            title: "email address",
            description: SCHOOL_SUPPORT_EMAIL,
        },
    ];

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted:", formData);
        alert("Thank you for contacting us!");
        setFormData({ name: "", email: "", message: "" });
    };

    return (
        <>
            <SeoContent title="Contact Us" />
            <section>
                <div className="section space-y-10">
                    {/* Contact Info Cards */}
                    <div className="grid grid-cols-1 gap-10 sm:grid-cols-2">
                        {contactInfo.map((info) => (
                            <div
                                key={info.id}
                                className="flex gap-4 rounded-md bg-primary p-6"
                            >
                                {info.icon}
                                <div className="flex flex-col gap-2 text-black">
                                    <span className="capitalize text-white">
                                        {info.title}
                                    </span>
                                    <p className="text-white">
                                        {info.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                
                   <div className="flex flex-col lg:flex-row gap-8">
    {/* Contact Form */}
    <div className="w-full lg:w-1/2 rounded-md bg-primary p-6 shadow-md">
        <h2 className="mb-6 text-2xl font-bold text-white">Send Us a Message</h2>
        <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 gap-6 sm:grid-cols-2"
        >
            <div className="col-span-2 sm:col-span-1">
                <label className="text-white">Your Name</label>
                <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="mt-1 w-full rounded-md p-3 text-sm outline-none"
                    placeholder="Enter your name"
                    required
                />
            </div>
            <div className="col-span-2 sm:col-span-1">
                <label className="text-white">Email</label>
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="mt-1 w-full rounded-md p-3 text-sm outline-none"
                    placeholder="Enter your email"
                    required
                />
            </div>
            <div className="col-span-2">
                <label className="text-white">Message</label>
                <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    className="mt-1 w-full rounded-md p-3 text-sm outline-none"
                    placeholder="Write your message"
                    required
                ></textarea>
            </div>
            <div className="col-span-2">
                <button
                    type="submit"
                    className="primary_btn w-full sm:w-auto"
                >
                    Send Message
                </button>
            </div>
        </form>
    </div>

    {/* Map Section */}
    <div className="w-full lg:w-1/2 rounded-md overflow-hidden">
        <SchoolMapLocation />
    </div>
</div>
</div>
            </section>
        </>
    );
}
